module.exports = __webpack_public_path__ + "static/media/solution27.e60ba90b.jfif";